export const findAssetsToDelete = ({ assets, item }) => {

    console.log("item----->", item)

    let itemsToDelete = []
    let nestedChildren = []

    if(item._id === null){      
        const allAssets = assets.map(item => { return item })
        itemsToDelete.push(...allAssets)    
    
    }else{

        const asset = assets.find(el => el._id === item._id)
        itemsToDelete.push(asset)

        const assetChildren = assets?.filter(el => el.parent === asset._id)
        itemsToDelete.push(...assetChildren)


        if(assetChildren.length>0){

            assetChildren.forEach(item => {
                const children  = assets.filter(el => el.parent === item._id)
                nestedChildren.push(...children)
            })
            itemsToDelete.push(...nestedChildren);
        }


    }

    console.log("items to delete----->", itemsToDelete)
    return itemsToDelete;

}